import { createContext } from 'react';

export const IdContext = createContext<string | undefined>(undefined);

export const { Provider: IdProvider } = IdContext;
